<template>
  <div
    v-if="!isFocused"
    class="overflow-hidden truncate placeholder-container"
    @click="$emit('focus')"
  >
    <AdminCellEmptyPlaceholder v-if="isEmpty" />
    <div v-else>
      <v-chip
        v-for="selection in theSelections"
        :key="selection"
        color="grey lighten-2"
        small
        class="proxima--font mr-1"
      >
        {{ selection }}
      </v-chip>
    </div>
  </div>
  <v-combobox
    v-else
    small-chips
    deletable-chips
    multiple
    allow-overflow
    v-model="theSelections"
    :items="items"
    no-data-text="Select"
    single-line
    autofocus
    v-tooltip="getTooltipHtml('Type and hit Enter to add a new option')"
    v-on="$listeners"
  />
</template>

<script>
import AdminCellEmptyPlaceholder from '@/components/AdminCellEmptyPlaceholder'
export default {
  name: 'AdminInputMultiselect',
  components: { AdminCellEmptyPlaceholder },
  props: {
    items: {
      type: Array,
      require: true,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    isFocused: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    theSelectionsFormatted() {
      return this.isEmpty ? 'Nothing Selected' : this.theSelections.join(', ')
    }, // theSelectionsFormatted
    isEmpty() {
      return !this.theSelections.length
    }, // isEmpty
  },
  data() {
    return {
      theSelections: this.value,
      search: '',
    }
  },
  methods: {
    getTooltipHtml(string) {
      return {
        content: `<div class="proxima--font">${string}</div>`,
        html: true,
      }
    }, // getTooltipHtml
  },
  watch: {
    value(value) {
      this.theSelections = value
    }, // value
  },
}
</script>

<style>
.admin-list-checkbox {
  cursor: pointer;
}
</style>
